import { forwardRef, type InputHTMLAttributes } from 'react';

import { classNames } from '../utils/class-names';
import styles from './input.component.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	/** Paint the invalid state (border + ring). Also sets aria-invalid. */
	invalid?: boolean;
}

/**
 * Presentational text input — a styled native `<input>` that forwards its ref.
 * Form binding (RHF) + label / error live in the field wrappers.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
	{ className, invalid, ...props },
	ref,
) {
	return (
		<input
			ref={ref}
			className={classNames(styles.input, className)}
			data-invalid={invalid || undefined}
			aria-invalid={invalid || undefined}
			{...props}
		/>
	);
});
